export const debounce = <T extends (...args: any[]) => any>(
  ms: number,
  callback: T
): ((...args: Parameters<T>) => Promise<Awaited<ReturnType<T>>>) => {
  let timer: NodeJS.Timeout | undefined;

  return (...args: Parameters<T>) => {
    if (timer) {
      clearTimeout(timer);
    }
    return new Promise<Awaited<ReturnType<T>>>((resolve) => {
      timer = setTimeout(() => {
        resolve(callback(...args));
      }, ms);
    });
  };
};
